import { CommonModule } from '@angular/common';
// import { HttpClient } from '@angular/common/http';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { RouterLink, Router } from '@angular/router';
import { AlertService, EnvironmentsService, IListing } from '@out-web/core';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { CapitalizeWithSpacesPipe } from '@out-web/core';
import { HttpClient } from '@angular/common/http';
import { RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha';
import { AuthService } from '@auth0/auth0-angular';
import { ButtonComponent } from '../../../atoms/button/button.component';
import { AlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'out-listing-contact-seller',
  imports: [
    RouterLink,
    CommonModule,
    CurrencyPipe,
    DecimalPipe,
    CapitalizeWithSpacesPipe,
    RecaptchaV3Module,
    ReactiveFormsModule,
    ButtonComponent,
    AlertComponent
  ],
  templateUrl: './listing-contact-seller.component.html',
  styleUrl: './listing-contact-seller.component.scss',
})
export class ListingContactSellerComponent implements OnInit, OnChanges {
  @Input() listingDetails!: IListing | null;
  @Input() includeInformationRequestCard = true;
  isContactModalOpen = false;
  private hasRecaptchaTriggered = false;
  requestInfoForm: FormGroup;
  isToggleOpen = false;
  isCommentOpen = false;
  formErrors: string[] = [];
  isLoading = false;
  isTaxModalOpen = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly environmentsService: EnvironmentsService,
    private readonly http: HttpClient,
    private recaptchaV3Service: ReCaptchaV3Service,
    private alertService: AlertService,
    private router: Router,
    public auth: AuthService
  ) {
    this.requestInfoForm = this.formBuilder.group({
      ListingId: [''],
      ShortId: [''],
      Recaptcha: ['', [Validators.required]],
      FirstName: ['', [Validators.required, this.noWhitespaceValidator]],
      LastName: ['', [Validators.required, this.noWhitespaceValidator]],
      ZipCode: ['', [Validators.required]],
      EmailAddress: ['', [Validators.required, Validators.email]],
      Phone: ['', [Validators.pattern(/^\d{3}-\d{3}-\d{4}$/)]],
      InquiryType: [''],
      Comments: [''],
    });
  }

  ngOnInit(): void {
    this.listenToEmailFieldValidation();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['listingDetails'] && this.listingDetails?.shortId) {
      this.requestInfoForm.patchValue({
        ShortId: this.listingDetails.shortId,
        ListingId: this.listingDetails.id,
      });
    }
  }

  async onSubmit() {
    this.isLoading = true;
    if (this.requestInfoForm.valid) {
      try {
        await this.http
          .post(
            `${this.environmentsService.url}/v1.1/Listings/Enquiry`,
            this.requestInfoForm.value
          )
          .toPromise();
        this.isLoading = false;
        this.isContactModalOpen = false;
        this.requestInfoForm.reset();
        this.alertUser();
      } catch (error) {
        console.log('Form not submitted', error);
        this.isLoading = false;
        this.alertService.showAlert({
          title: 'Error sending message',
          message: 'We could not send your message. Please try again later.',
          type: 'error',
          duration: 5000,
          position: 'top-right',
        });
      }
    } else {
      this.requestInfoForm.markAllAsTouched();
      this.isLoading = false;
      this.updateFormErrors();
      console.log('Form not valid');
    }
  }

  alertUser() {
    const alertType = 'success';
    const alertTitle = 'Message sent!';
    const alertMessage = 'The seller will contact you soon. Thank you.';

    this.alertService.showAlert({
      title: alertTitle,
      message: alertMessage,
      type: alertType,
      duration: 5000,
      position: 'top-right',
    });
  }

  listenToEmailFieldValidation(): void {
    const emailControl = this.requestInfoForm.get('EmailAddress');

    if (emailControl) {
      emailControl.statusChanges.subscribe(() => {
        if (emailControl.valid && !this.hasRecaptchaTriggered) {
          this.executeRecaptcha('form');
          this.hasRecaptchaTriggered = true;
        }
      });
    }
  }

  executeRecaptcha(action: string): void {
    this.recaptchaV3Service.execute(action).subscribe((token) => {
      this.requestInfoForm.controls['Recaptcha'].setValue(token);
      console.log(`Recaptcha action ('${action}') and token`, token);
    });
  }

  updateFormErrors() {
    this.formErrors = [];
    Object.keys(this.requestInfoForm.controls).forEach((key) => {
      // Skip the Recaptcha field
      if (key === 'Recaptcha') {
        return;
      }
      
      const controlErrors = this.requestInfoForm.get(key)?.errors;
      if (controlErrors) {
        if (controlErrors['required']) {
          this.formErrors.push(
            `${key
              .replace(/([A-Z])/g, ' $1')
              .replace(/\w\S*/g, (txt) =>
                txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
              )} is not valid.`
          );
        } else if (controlErrors['email']) {
          this.formErrors.push(`Email is not valid.`);
        }
      }
    });
  }

  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  showComment() {
    this.isCommentOpen = !this.isCommentOpen;
  }

  toggleContactDialog(event: Event) {
    if (event.target === event.currentTarget) {
      this.isContactModalOpen = !this.isContactModalOpen;
    } else {
      event.stopPropagation();
    }
  }
  toggleDialog() {
    this.isContactModalOpen = !this.isContactModalOpen;
    if (this.isToggleOpen) {
      this.executeRecaptcha('form');
    }
  }

  login() {
    this.auth.loginWithRedirect({
      appState: { target: this.router.url }
    });
  }

  toggleTaxDialog() {
    this.isTaxModalOpen = !this.isTaxModalOpen;
  }
}
